var map = {
	"./tutor_1.png": 2,
	"./tutor_2.png": 7672,
	"./tutor_3.png": 4092,
	"./tutor_4.png": 7191,
	"./tutor_dummy.png": 3446,
	"./tutor_dummy_2.png": 5418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3984;